<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <AError
      v-if="api.isError"
      :api="api"
      :callbackReset="() => (userApi.arror = false)"
    ></AError>
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col cols="12" sm="6">
          <h2>Edit Classroom</h2>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="d-flex justify-center justify-sm-end">
            <div>
              <v-btn rounded outlined color="red" dark :to="{name:'PageEducatorInstitutionClassroomDelete',params:{id:this.$route.params.id,parentId:this.$route.params.parentId}}"> Delete </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-card-title></v-card-title>
      <div class="d-flex align-center justify-space-around">
        <div class="form-content text-center">
          <v-form ref="formName" v-model="valid" lazy-validation>
            <div class="text-center pt-3">
              <TextField
                :value="name"
                label="Classroom name"
                :rules="nameRules"
                type="text"
                @input="name = $event"
              ></TextField>
            </div>
            <div class="text-center pt-3">
              <SelectField
                :value="schoolYear"
                :field="selectSchoolYearField"
                @input="schoolYear = $event"
                label="School Year"
              ></SelectField>
            </div>
            <div class="text-left text-caption">
              <div>First School Date</div>
            </div>
            <div class="d-flex">
              <div class="text-center pt-3">
              <SelectField
                :value="month"
                :field="selectMonthField"
                @input="month = $event"
                label="Month"
              ></SelectField>
            </div>
            <div class="text-center pt-3 pl-3">
              <SelectField
                :value="year"
                :field="selectYearField"
                @input="year = $event"
                label="Year"
              ></SelectField>
            </div>
            </div>
            <div class="text-center py-0 d-none">
              <CheckBoxField :value="isWalkin" label="Enable Walkin" @input="isWalkin = $event"></CheckBoxField>
            </div>
            <div class="text-center pt-1">
              <v-btn :loading="api.isLoading" width="75%" rounded color="primary" dark @click="submit()">
                Submit
              </v-btn>
            </div>
            <div class="text-center pt-2">
              <v-btn
                width="75%"
                rounded
                text
                color="primary"
                dark
                @click="$router.go(-1)"
              >
                Cancel
              </v-btn>
            </div>
          </v-form>
        </div>
      </div>
    </v-card>
  </v-container>
</template>
    
    <script>
import TextField from "@/components/Form/TextField.vue";
import CheckBoxField from "@/components/Form/CheckBoxField.vue";
import datasetSchoolYears from "@/datasets/schoolYear";
import datasetMonths from "@/datasets/month";
import datasetYears from "@/datasets/year";
import SelectField from "@/components/Form/SelectField.vue";
import { mapState } from "vuex";
export default {
  components: {
    SelectField,
    TextField,
    CheckBoxField,
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    name: null,
    isWalkin: false,
    nameRules: [],
    id:null,
    //BOC:[api]
    classroomApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    selectSchoolYearField: {
      defaultValue: null,
      name: "School Year",
      options: datasetSchoolYears,
      optionText: "name",
      optionValue: "id",
    },
    schoolYear:null,
    selectMonthField: {
      defaultValue: null,
      name: "Month",
      options: datasetMonths,
      optionText: "name",
      optionValue: "id",
    },
    month:null,

    selectYearField: {
      defaultValue: '',
      name: "Year",
      options: datasetYears,
      optionText: "",
      optionValue: "",
    },
    year:'',
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      },
      {
        text: "My Institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.parentId },
        },
        exact: true,
      },
      {
        text: "Classrooms",
        to: {
          name: "PageEducatorInstitutionClassroom",
          params: { id: this.$route.params.parentId },
        },
        exact: true,
      },
      {
        text: "Classroom",
        to: { name: "PageEducatorInstitutionClassroomDashboard" },
        exact: true,
      },
      {
        text: "Info",
        to: { name: "PageEducatorInstitutionClassroomRead" },
        exact: true,
      },
      {
        text: "Edit",
        to: { name: "PageEducatorInstitutionClassroomEdit" },
        exact: true,
      },
    ];
    //EOC
    this.classroomApi.method = "GET";
    this.classroomApi.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/institution/"+this.$route.params.parentId+"/classroom/" +
      this.$route.params.id;

      this.classroomApi.callbackReset = () => {
      this.classroomApi.isLoading = true;
      this.classroomApi.isError = false;
    };

    this.classroomApi.callbackError = (e) => {
      this.classroomApi.isLoading = false;
      this.classroomApi.isError = true;
      this.classroomApi.error = e;
    };

    this.classroomApi.callbackSuccess = (resp) => {
      this.classroomApi.isLoading = false;
      this.name = resp.name
      this.isWalkin = resp.enableWalkin
      this.year = resp.year
      this.schoolYear = resp.schoolYear
      this.month = resp.month
      // this.updateBreadcrumb(resp)
    };

    this.api.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/institution/"+this.$route.params.parentId+"/classroom/edit";

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = () => {
      this.api.isLoading = false;
      this.$router.push({ name: "PageEducatorInstitutionClassroom",params:{id:this.$route.params.parentId} });
    };
  },
  mounted() {
    this.$api.fetch(this.classroomApi);
    this.id = this.$route.params.id;
  },
  watch: {
    name: function () {
      this.nameRules = [];
    },
  },
  methods: {
    // updateBreadcrumb(resp) {
    //   this.breadcrumbs.push({
    //     text: "Dashboard",
    //     to: { name: "PageEducatorDashboard" },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: resp.Institution.name,
    //     to: { name: "PageEducatorInstitutionDashboard",params:{id:this.$route.params.parentId} },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: 'Classrooms',
    //     to: { name: "PageEducatorInstitutionClassroom",params:{id:this.$route.params.parentId} },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: resp.name,
    //     to: { name: "PageEducatorInstitutionClassroomDashboard" ,params:{id:this.$route.params.id,parentId:this.$route.params.parentId}},
    //     exact: true,
    //   });

    //   this.breadcrumbs.push({
    //     text: "Edit",
    //     to: { name: "PageEducatorInstitutionClassroomEdit" },
    //     exact: true,
    //   });
    // },
    close() {
      this.$router.push({ name: "PageEducatorInstitutionClassroom",params:{id:this.$route.params.parentId} });
    },
    submit() {
      this.nameRules = [(v) => !!v || "Name is required"];
      let self = this;
      setTimeout(function () {
        if (self.$refs.formName.validate()) {
          self.api.params = {
            id:self.id,
            name: self.name,
            schoolYear: self.schoolYear,
            year: self.year,
            month: self.month,
            enableWalkin: self.isWalkin,
          };
          self.$api.fetch(self.api);
        } else {
          self.api.callbackError("Please check the form.");
        }
      });
    },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 300px !important;
}
</style>